module.exports = __webpack_public_path__ + "static/media/pic_9.25605cec.jpg";